




















import { Vue, Component } from "vue-property-decorator";

const LOGO_MASK =
  "https://product-configurator-assets.s3.eu-central-1.amazonaws.com/loader_logo.png";
const LOGO_FULL =
  "https://product-configurator-assets.s3.eu-central-1.amazonaws.com/loader_logo_full.svg";

@Component({})
export default class IlmyoLoader extends Vue {
  contourLoaded = false;

  get maskUrl() {
    return LOGO_MASK;
  }

  get logoUrl() {
    return LOGO_FULL;
  }
}
